import React from 'react'

import PropTypes from 'prop-types'

import AtomCard from '@s-ui/react-atom-card'

import CardUserContent from './card-user-content.js'

const getContent =
  ({adId, hasCriteoEvents, hidePhone, leadData, multiprovince, user}) =>
  () =>
    (
      <CardUserContent
        adId={adId}
        hasCriteoEvents={hasCriteoEvents}
        hasPhoneNumber={!hidePhone}
        leadData={leadData}
        multiprovince={multiprovince}
        {...user}
      />
    )

const CardUser = ({
  adId,
  hasCriteoEvents = false,
  hidePhone,
  isLoggedUser,
  leadData = {},
  multiprovince = '',
  pageName,
  user
}) => {
  return (
    <div className="mt-CardUser">
      <AtomCard
        content={getContent({adId, hasCriteoEvents, hidePhone, isLoggedUser, leadData, multiprovince, pageName, user})}
      />
    </div>
  )
}

CardUser.displayName = 'CardUser'
CardUser.propTypes = {
  adId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasCriteoEvents: PropTypes.bool,
  hidePhone: PropTypes.bool,
  isLoggedUser: PropTypes.bool,
  leadData: PropTypes.object,
  multiprovince: PropTypes.string,
  pageName: PropTypes.string,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    province: PropTypes.string,
    avatar: PropTypes.string
  }).isRequired
}

export default CardUser
